export const marginType = {
  percent: "percent",
  value: "value",
};
